import { apiClient, apiClientAuth } from "../http/httpClient";


export function UserApi(contentType = "application/json")
{
    const http = apiClient(contentType);
    const https = apiClientAuth(contentType);

    return {
  
        /**
        * Route publique - Authentification
        * POST /api/users/login
        */
        auth : (data) => http.post("/api/users/login", data),
        
        /**
        * Route publique - Inscription
        * POST /api/users/register
        */
        insert : (data) => http.post("/api/users/register", data), 

        /**
        * Route publique - Activation de compte
        * PUT /api/users/activate
        */
        activateAccount : (activationToken) => http.put("/api/users/activate", activationToken),

        /**
        * Route publique - Réinitialisation de mot de passe
        * PUT /api/users/set-password
        */
        updatePassword : (password) => http.put("/api/users/set-password", password), 

        /**
        * Route publique - Mot de passe oublié
        * POST /api/users/forgot-password
        */
        genPasswordToken : (email) => http.post("/api/users/forgot-password", email), 

        /**
        * Route protégée - Récupérer l'utilisateur courant
        * GET /api/users/current/me
        */
        findCurUser: () => https.get(`/api/users/current/me`),
        
        /**
        * Route protégée - Récupérer un utilisateur par ID
        * GET /api/users/:id
        */
        findOne: (id) => https.get(`/api/users/${id}`),

        /**
        * Route protégée - Mettre à jour un email d'inscription
        * PUT /api/users/resend-activation-email
        */
        updateEmail: (email) => https.post(`/api/users/resend-activation-email`, email),
        
      };
}

